module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraBold.woff?45ce9384f5d829596586a3b2fa1224a4";